import React from "react";
import { Helmet } from "react-helmet";

const SEO = () => {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "High Q Consulting",
    url: "https://www.highqc.com",
    logo: "https://www.highqc.com/logo.png",
    description:
      "High Q Consulting is a dedicated consulting firm passionate about supporting the food and allied industries in standardization, regulation, and conformance.",
    contactPoint: {
      "@type": "ContactPoint",
      telephone: "+971554096269",
      contactType: "customer service",
      email: "support@highqc.com",
      areaServed: "AE",
      availableLanguage: ["English"],
    },
    address: {
      "@type": "PostalAddress",
      streetAddress:
        "Al Zahia Area - Entrance No. 2 - Ground Floor - Sheikh Mohammed Bin Zayed Rd",
      addressLocality: "Sharjah",
      addressCountry: "United Arab Emirates",
    },
    sameAs: [],
    hasOfferCatalog: {
      "@type": "OfferCatalog",
      name: "Consulting and Training Services",
      itemListElement: [
        {
          "@type": "Offer",
          itemOffered: { "@type": "Service", name: "Product Registration" },
        },
        {
          "@type": "Offer",
          itemOffered: { "@type": "Service", name: "Regulatory Services" },
        },
        {
          "@type": "Offer",
          itemOffered: { "@type": "Service", name: "Certification Support" },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Product Safety Implementation",
          },
        },
        {
          "@type": "Offer",
          itemOffered: { "@type": "Service", name: "Conformity Assessment" },
        },
        {
          "@type": "Offer",
          itemOffered: { "@type": "Service", name: "Documentation Support" },
        },
        {
          "@type": "Offer",
          itemOffered: { "@type": "Service", name: "Accreditation Support" },
        },
        {
          "@type": "Offer",
          itemOffered: { "@type": "Service", name: "Quality Management" },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Halal & Food Safety Training",
          },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Quality And Standardization Training",
          },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Conformity Assessment Training",
          },
        },
        {
          "@type": "Offer",
          itemOffered: { "@type": "Service", name: "Customized Training" },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Ingredients & Additives Consulting",
          },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Machinery And Instrumentation",
          },
        },
        {
          "@type": "Offer",
          itemOffered: { "@type": "Service", name: "Logistics Support" },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Custom Clearance Assistance",
          },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Business Website",
          },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Tax Registration",
          },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Business Setup",
          },
        },
        {
          "@type": "Offer",
          itemOffered: {
            "@type": "Service",
            name: "Business Documentation",
          },
        },
      ],
    },
  };

  return (
    <Helmet>
      {/* 🔍 Basic Meta Tags */}
      <title>High Q Consulting | Food Safety & Regulatory Consulting UAE</title>
      <meta
        name="description"
        content="High Q Consulting provides expert food safety, regulatory, and quality management consulting services in the UAE. We specialize in product registration, certification, and training for food and allied industries."
      />
      <meta
        name="keywords"
        content="High Q Consulting, Food Safety, Regulatory Services, Product Registration, Certification, Quality Management, UAE, Halal Certification, Food Industry Consulting"
      />

      {/* 🌍 Open Graph (Facebook, LinkedIn) */}
      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content="High Q Consulting | Food Safety & Regulatory Consulting UAE"
      />
      <meta
        property="og:description"
        content="We help food and allied industries achieve global standards through product registration, certification, and quality management consulting in the UAE."
      />
      <meta property="og:url" content="https://www.highqc.com" />
      <meta property="og:site_name" content="High Q Consulting" />
      <meta property="og:image" content="https://www.highqc.com/logo.png" />

      {/* 🐦 Twitter Meta */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="High Q Consulting | Food Safety & Regulatory Consulting UAE"
      />
      <meta
        name="twitter:description"
        content="Expert consulting in food safety, regulatory compliance, and certification support in the UAE."
      />
      <meta name="twitter:image" content="https://www.highqc.com/logo.png" />

      {/* 📱 Mobile / Robots */}
      <meta name="robots" content="index, follow" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />

      {/* 📦 JSON-LD Structured Data */}
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
    </Helmet>
  );
};

export default SEO;
